var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ nomobile: !_vm.isMobile },style:(_vm.swayStyle),attrs:{"id":"app"},on:{"dblclick":_vm.toggleBodyClass}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }